import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-[hsl(0_0%_18%)] text-primary-foreground">
      <div className="max-w-7xl mx-auto px-6 pt-20 pb-8">
        <div className="flex flex-col md:flex-row gap-16">
          {/* Brand */}
          <div className="md:max-w-xs">
            <div className="mb-6">
              <span className="font-display text-3xl tracking-[0.05em] text-primary-foreground">Capshot Visuals</span>
              
            </div>
            <p className="text-xs text-[hsl(0_0%_100%/0.5)] leading-relaxed tracking-wide font-light">
              {t("footer.tagline")}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-8">
            {/* Navigation */}
            <div>
              <p className="text-[9px] tracking-[0.3em] uppercase text-[hsl(0_0%_100%/0.52)] font-semibold mb-6">{t("footer.navigation")}</p>
              <nav className="flex flex-col gap-3">
                {[
                  { label: t("nav.services"), path: "/services" },
                  { label: t("nav.about"), path: "/about" },
                  { label: t("nav.contact"), path: "/contact" },
                ].map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className="text-xs text-[hsl(0_0%_100%/0.55)] hover:text-primary-foreground tracking-[0.15em] uppercase transition-colors font-light"
                  >
                    {item.label}
                  </Link>
                ))}
              </nav>
            </div>

            {/* Contact */}
            <div>
              <p className="text-[9px] tracking-[0.3em] uppercase text-[hsl(0_0%_100%/0.52)] font-semibold mb-6">{t("footer.getInTouch")}</p>
              <div className="flex flex-col gap-4">
                <a href="mailto:hello.capshotvisuals@gmail.com" className="flex items-center gap-3 text-xs text-[hsl(0_0%_100%/0.55)] hover:text-primary-foreground transition-colors tracking-wide font-light">
                  <Mail size={13} /> hello.capshotvisuals@gmail.com
                </a>
                <a href="https://wa.me/36304789420" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-xs text-[hsl(0_0%_100%/0.55)] hover:text-primary-foreground transition-colors tracking-wide font-light">
                  <MessageCircle size={13} /> WhatsApp
                </a>
                <a href="https://www.instagram.com/capshot.visuals" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-xs text-[hsl(0_0%_100%/0.55)] hover:text-primary-foreground transition-colors tracking-wide font-light">
                  <Instagram size={13} /> @capshot.visuals
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full h-px bg-[hsl(0_0%_100%/0.1)] mt-14 mb-2" />
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[10px] text-[hsl(0_0%_100%/0.52)] tracking-[0.2em] uppercase font-light">
            © {new Date().getFullYear()} Capshot Visuals. {t("footer.rights")}
          </p>
          
        </div>
      </div>
    </footer>
  );
}
